import { datadogRum } from '@datadog/browser-rum';

/**
 * Logs an error to DataDog RUM with a custom searchable message while preserving the original stack trace.
 *
 * @param message - Custom searchable message for DataDog
 * @param originalError - The original error object
 * @param context - Additional context to attach to the error
 */
export function sendDatadogRumError(message: string, originalError: unknown, context?: object): void {
    const error = new Error(message, { cause: originalError });
    if (originalError instanceof Error && originalError.stack) {
        error.stack = originalError.stack;
    }
    datadogRum.addError(error, {
        ...context,
        cause: originalError instanceof Error ? originalError.cause : undefined,
    });
}

/**
 * Sends a custom action to DataDog RUM for behavioral/funnel instrumentation.
 *
 * @param name - Searchable action name (e.g. 'checkout_stalled')
 * @param context - Additional context attached to the action
 */
export function sendDatadogRumAction(name: string, context?: object): void {
    datadogRum.addAction(name, context);
}
